module.exports = __webpack_public_path__ + "c1d4146df629cd6a19142ec5ec692b98.svg";